import React from "react";
import { useNavigate } from "react-router-dom";

const BookingPopUp = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // Go back to previous screen
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
      <div className="bg-white p-6 rounded-2xl shadow-lg max-w-sm w-full text-center relative">
        {/* Close Button (X) */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl font-bold"
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">Coming Soon</h2>
        <p className="text-gray-600 mb-6">Bookings will be available soon.</p>

        {/* OK Button */}
        <button
          onClick={handleClose}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default BookingPopUp;
